export const shouldFreezeColumnByHeaderName = (headerName: string, headersToFreeze: string[], caseInsensitive = true): boolean => {
    if (caseInsensitive) {
        const lowerCaseHeadersToFreeze = headersToFreeze.map((header) => header.toLowerCase());
        return lowerCaseHeadersToFreeze.includes(headerName.toLowerCase());
    } else {
        return headersToFreeze.includes(headerName);
    }
};
